<div class="overview__header">
  <div class="overview__name-review">
    <h2 class="overview__header-text">
      {{identifier}} {{ airport.name }}
      <mat-icon (click)="openEditIslandOverviewDialog()" *ngIf="editModeSet && (airport.sourceId === 10
    || airport.sourceId === 12)" class="edit-icon" mat-tooltip="Edit" aria-label="Edit airport overview">edit</mat-icon>
    </h2>
    <app-review-overview *ngIf="airport.reviewSummary" [reviewSummary]="airport.reviewSummary"></app-review-overview>
  </div>
  <div class="overview__header-actions">
    <app-airport-home-icon [identifier]="airport.identifier" [faaid]="airport.faaId"></app-airport-home-icon>
    <app-airport-favorite-icon [identifier]="airport.identifier"></app-airport-favorite-icon>
  </div>
</div>
<div class="overview__subheader">
  <div *ngIf="airport.address1" class="overview__address1">
    {{ airport.address1 }}
  </div>
  <div *ngIf="airport.address2" class="overview__address2">
    {{ airport.address2 }}
  </div>
  <div *ngIf="airport.city && airport.stateProvince" class="overview__city-state-zip">
    {{ airport.city }}, {{ airport.stateProvince }} {{ airport.postalCode }}
  </div>
  <div *ngIf="airport.country && airport.country !== 'US'" class="overview__address2">
    {{ airport.country }}
  </div>
  <div *ngIf="airport.mainPhone" class="overview__contact">{{ airport.mainPhone | phone }}</div>
  <div *ngIf="airport.website || editModeSet">
    <mat-icon (click)="openEditWebsiteDialog()" *ngIf="editModeSet && (airport.sourceId !== 10 && airport.sourceId !== 12)" class="edit-icon" mat-tooltip="Edit" aria-label="Edit website URL">edit</mat-icon>
    <a *ngIf="airport.website; else noWebsite" class="overview__website" [href]="website" target="_blank">{{ airport.website }}</a>
  </div>
  <div>
    <button class="mat-button aopa-mat-btn aopa-mat-btn--filled suggest-a-change" (click)="openSuggestAChangeDialog()">Suggest a Change to this Page</button>
  </div>
  <!-- <div>
    <a (click)="navigateToWx()" mat-button
       class="overview__action aopa-mat-btn aopa-mat-btn--filled">
      Webcams ({{getWebcamCount()}})
    </a>
  </div> -->
</div>
<ng-template #noWebsite>
  <ng-container *ngIf="editModeSet"><a class="overview__website" (click)="openEditWebsiteDialog()">Add website URL</a></ng-container>
</ng-template>
